import { APPROVAL_BLOCKED_STATUSES } from '@/shared/config';

export function transitionDropsApprovals(
  from: string,
  to: string,
  pendingCount: number,
  fromFinal = false,
): boolean {
  if (pendingCount <= 0 || from === to) return false;
  if (fromFinal || APPROVAL_BLOCKED_STATUSES.includes(from)) return false;
  return from === 'on_approval' || APPROVAL_BLOCKED_STATUSES.includes(to);
}
